import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-53e56079")

_pushScopeId("data-v-53e56079")
const _hoisted_1 = { class: "karte-item-row" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", null, "項目一覧", -1)
const _hoisted_3 = { class: "karte-item-row" }
const _hoisted_4 = { class: "karte-item-button-row" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("項目追加 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("項目削除 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("カルテ項目を削除してもいいですか？ ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_list_box = _resolveComponent("list-box")
  const _component_fa_icon = _resolveComponent("fa-icon")
  const _component_normal_button = _resolveComponent("normal-button")
  const _component_confirm = _resolveComponent("confirm")
  const _component_vue_content = _resolveComponent("vue-content")

  return (_openBlock(), _createBlock(_component_vue_content, null, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_list_box, {
          id: "karte-item-list-box",
          title: "カルテ項目",
          items: _ctx.listBoxKarteItems,
          modelValue: _ctx.selectedKarteItemId,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedKarteItemId = $event)),
          size: _ctx.listSize
        }, null, 8, ["items", "modelValue", "size"])
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_normal_button, {
            class: "add-item-button",
            state: "normal",
            disabled: _ctx.isFirst || _ctx.selectedKarteItemId === '' || !_ctx.dataWrite,
            onClick: _ctx.upItem
          }, {
            default: _withId(() => [
              _createVNode(_component_fa_icon, { icon: "arrow-up" })
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_normal_button, {
            class: "add-item-button",
            state: "normal",
            disabled: _ctx.isLast || _ctx.selectedKarteItemId === '' || !_ctx.dataWrite,
            onClick: _ctx.downItem
          }, {
            default: _withId(() => [
              _createVNode(_component_fa_icon, { icon: "arrow-down" })
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]),
        _createVNode(_component_normal_button, {
          class: "add-item-button",
          state: "normal",
          disabled: !_ctx.dataWrite,
          onClick: _ctx.addItem
        }, {
          default: _withId(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_normal_button, {
          class: "add-item-button",
          state: "delete",
          disabled: _ctx.selectedKarteItemId==='' || !_ctx.dataWrite,
          onClick: _ctx.onDelete
        }, {
          default: _withId(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      _createVNode(_component_confirm, {
        ref: "confirmDeleteRef",
        onYes: _ctx.yesDelete
      }, {
        default: _withId(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["onYes"])
    ]),
    _: 1
  }))
})